//大小寫需一致
const zh_cn = {
  'app.learn': '学习 {name}'
  , "app.Salmon": "{name} 三文鱼"
  , "app.loginMessage": "请输入您的帐号、密码"
  //UserInfo
  , "app.screenLockMessage": "请输入您的密码"
  , "app.screenLock": "屏幕锁定"
  , "app.loginMessage_Error": "帐号或密码错误"
  , "app.PasswordNotMatch": "新密码不一致"
  , "passwordOld": "旧密码"
  , "passwordNew": "新密码"
  , "passwordConfirm": "新密码确认"
  , "app.changePw": "变更密码"

  , "username": "帐号"
  , "password": "密码"
  , "app.Languages": "语言"
  , "app.Colors": "颜色"
  , "app.pleaseSelect": "请选择..."
  , "app.add": "新增"
  , "app.addPlus": "新增+"
  , "app.sendCheck": "送审"
  , "app.delete": "删除"
  , "app.Edit": "编辑"
  , "app.Undelete": "反删除"
  , "app.Audit": "审核"
  , "app.UnAudit": "反审核"
  , "app.Cancel": "取消"
  , "app.UploadYourFile": "请上传档案..."
  , "app.Submit": "上传"
  , "app.isDelete": "确认是否删除?"
  , "app.UploadYourFile": "请上传档案..."
  , "app.administrator": "管理员无法被修改"
  , "app.haveData": "尚有明细无法删除"
  , "app.Query": "查询"
  , "app.CloseAll": "关闭所有"
  , "app.CloseOthers": "关闭其他"
  // helperText for Validator
  , "noRepeat": "不可重复"
  , "required": "必填"
  , "minLength": "最小长度"
  , "maxLength": "最大长度"
  //EmployeeTable
  , "EmployeeTable": "员工列表"
  , "empName": "姓名"
  , "empAddress": "地址"
  , "pensionRate": "退休金率"
  , "seniorityY": "年资(Y)"
  , "seniorityM": "年资(M)"
  , "seniorityMTotal": "总年资(M)"
  , "empPhone": "电话"
  , "companyId": "公司"
  , "companyName": "公司"
  , "empSID": "身分证号"
  , "empAccount": "帐号"
  , "email": "email"
  , "gender": "性别"
  , "genderText": "性别"
  , "dateBirth": "生日"
  , "dateQuit": "离职日"
  , "dateHire": "雇用日"
  , "dateCreate": "资料创建日"
  , "ExemptClock": "需要打卡"
  , "ExemptClockText": "需要打卡"

  //CompanyTable
  , "CompanyTable": "公司列表"
  , "companyName": "公司名称"
  , "taxNumber": "税号"
  , "address": "地址"
  , "prefixTitle": "前缀"
  , "ZipCode": "邮编"
  ////ShiftsTable
  , "ShiftsTable": "班别设定"
  , "sqShift": "班别"
  , "shiftsName": "班别名称"
  , "WorkTimeStart": "上班时间"
  , "WorkTimeEnd": "下班时间"
  , "RestTimeStart": "休息开始"
  , "RestTimeEnd": "休息结束"
  , "workhours": "工时"
  //WageTypeTable
  , "WageTypeTable": "薪资类型表"
  , "name": "名称"
  , "kind": "类型"
  , "DateAdd": "新增日期"
  , "currencyId": "币别"
  , "amount": "金额"
  , "wageStructure": "薪资结构"
  , "wageHistory": "历史薪资"
  //empInsurance
  , "subSq": "No."
  , "salaryRank": "薪水级距"
  , "labourInsurance": "劳保(个人)"
  , "labourInsuranceEntity": "劳保(企业)"
  , "healthCare": "健保(个人)"
  , "healthCareEntity": "健保(企业)"
  , "year": "Year"
  , "DateFrom": "起始日"
  , "DateTo": "结束日"
  , "local": "区域"
  //LeaveTypeContainer
  , "LeaveTypeContainer": "LeaveTypeContainer"
  , "sqLeaveType": "假别类别"
  , "LeaveTypeName": "假别类别"
  , "empId_applicant": "申请人"
  , "LeaveApplicantName": "申请人"
  , "empId_substitute": "代理人"
  , "LeaveSubstituteName": "代理人"
  , "dateFrom": "起始日期"
  , "dateTo": "结束日期"
  , "hours": "请假时数"
  , "checkType": "签核状态"
  , "CheckTypeName": "签核状态"
  , "leaveDescription": "说明"

    //roles
  ,"RolesSetting":"角色设定"
  ,"rolesName":"角色名称"
  //Attendance
  ,"AttendanceUploadTitle":"出勤上传"
  ,"isUpload":"是否上传"
  ,"AttendanceRecordTitle":"出勤纪录"
  ,"everyday":"日期"
  ,"AttendanceStatus":"出勤状况"
  ,"isWorkday":"上班日"
  ,"clockDate":"打卡日期"
  ,"startTime":"上班打卡时间"
  ,"endTime":"下班打卡时间"
  ,"manualStartTime":"手动上班时间"
  ,"manualEndTime":"手动下班时间"
  //AttendanceAdjust
  , "AttendanceAdjustEmpTitle": "出勤人员"
  , "PersonalAttendanceAdjustTitle": "出勤时数"
  , "WorkOwedHours": "积欠小时"
  , "WorkOverTime": "加班小时"
  , "manualWorkOwedHours": "修正请假时数"
  , "manualWorkOverTime": "修正加班时数"
  , "AdjustConfirm": "调整确认"
  , "AdjustDelete": "删除调整"
  , "AdjustTextNotConfirm": "未确认调整"
  , "AdjustTextConfirmed": "确认调整时间:"
  //WageCalculatorTable
  , "WageCalculatorTitle": "薪资计算表"
  , "BasicAmt": "薪资"
  , "workOverTime133": "加班时数(一皆)"
  , "workOverTime166": "加班时数(二皆)"
  , "overtimeExpenses": "加班费"
  , "workOwedTime": "请假/迟到时数"
  , "owedExpenses": "请假/迟到扣薪"
  , "totalSalary": "总薪资"
  , "levelRank": "投保级距"
  , "selfSaving": "员工自提"
  , "pensionEntity": "退休金"
  , "actualSalary": "实付薪资"
  , "actualSalaryWithBonus": "实付薪资(含奖金)"
  , "manualBonus01": "奖金(一)"
  , "manualBonus02": "奖金(二)"
  , "manualBonus03": "奖金(三)"
  , "setAllmanualBonus01": "设定全奖金(一)"
  , "setAllmanualBonus02": "设定全奖金(二)"
  , "setAllmanualBonus03": "设定全奖金(三)"

  //JobsType
  ,"sqJobsType":"NO."
  ,"JobsTypeName":"工作性质"
  //CalendarTable
  ,"holidayDescription":"描述"
  ,"multiplierRate":"系数"
  ,"DateRest":"日期"

};
export default zh_cn;